import React from "react";
import ButtonSkaRound from "../../aGlobalDesign/Buttons/ButtonSkaRound";
import { useSelector } from "react-redux";

const EmptyCarouselItem = ({ addAd }) => {

    const currentUser = useSelector((state) => state.currentuser);
    const accessrights = currentUser && currentUser.accessrights ? currentUser.accessrights : null;

    return (
        <div className='carousel-empty-item-container'>
            <div className='carousel-thumb-empty'></div>
            <div className='carousel-action'>
                <ButtonSkaRound
                    type="primary"
                    isDisabled={!accessrights || accessrights.hasPermission(700, "create") <= 10}
                    onClick={() => addAd()}
                    nameIcon="add"
                />
            </div>
        </div>
    );
};

export default EmptyCarouselItem;
